import { useState } from 'react';

export default function useCart() {
  const getCart = () => {
    const cart = localStorage.getItem('shoppingCart');
    if(cart) {
      return JSON.parse(cart);
    }
    return [];
  };

  const [cart, setCart] = useState(getCart());

  const addToCart = (product: any) => {
    let cart = getCart() || [];
    if(!cart) {
        localStorage.setItem('shoppingCart', "");
    }
    if(cart.find((p: any) => p.productSize.id == product.productSize.id)){
        let existingProduct = cart.find((p: any) => p.productSize.id === product.productSize.id);
        existingProduct.quantity += product.quantity;
        cart = cart.filter((p: any) => p.productSize.id !== product.productSize.id);
        cart.push(existingProduct);
    } 
    else
        cart.push(product);
    localStorage.setItem('shoppingCart', JSON.stringify(cart));
    setCart(cart);
    return cart;
  };

  const removeProduct = (id: string) => {
    const cart = getCart();
    if(!cart) return;
    const newCart = cart.filter((product: any) => product.id !== id);
    localStorage.setItem('shoppingCart', JSON.stringify(newCart));
    setCart(newCart);
  };

  return {
    removeProduct: removeProduct,
    addToCart: addToCart,
    cart
  }
}
